import React from 'react';
import { FlexBox, MaxHeightContainer } from '@eltoro-ui/components';
import { Skeleton } from 'primereact/skeleton';
import { Layout } from 'Components';
import { CampaignCreationWrapper } from 'Pages/CampaignCreation/components/CampaignCreationWrapper';
import './CampaignCreationSkeleton.scss';

const CampaignCreationSkeleton = () => {
  return (
    <div className="Campaign_Skeleton">
      <MaxHeightContainer
        fullHeight
        header={
          <div className="Campaign_Skeleton__header">
            <Skeleton width="10rem" />
          </div>
        }
      >
        <div className="generated-campaign-layout">
          <Layout>
            <CampaignCreationWrapper>
              <div className="Campaign_Skeleton__craetives">
                <FlexBox flexDirection="column" gap="4px">
                  <Skeleton className="name-1" />
                  <Skeleton className="name-2" />
                </FlexBox>
                <Skeleton width="100%" className="image-wrapper">
                  <div className="circle-wrapper">
                    <Skeleton shape="circle" className="circle" />
                  </div>
                  <Skeleton className="image" />
                </Skeleton>
                <FlexBox gap="4px" justifyContent="space-around">
                  {Array.from({ length: 6 }).map((_, index) => (
                    <Skeleton key={index} className="small-imgs" />
                  ))}
                </FlexBox>
              </div>
              <FlexBox
                flexDirection="column"
                justifyContent="space-between"
                UNSAFE_className="summary-skeleton"
              >
                <FlexBox flexDirection="column" gap="8px">
                  <Skeleton width="10rem" />
                  <Skeleton width="100%" height="30px" />
                  <Skeleton width="10rem" />
                  <Skeleton width="100%" height="30px" />
                  <Skeleton width="10rem" />
                  <Skeleton width="100%" height="30px" />
                  <Skeleton width="10rem" />
                  <Skeleton width="100%" height="30px" />
                </FlexBox>
                <FlexBox flexDirection="column" gap="12px">
                  <FlexBox justifyContent="space-between" gap="12px">
                    <Skeleton width="10rem" />
                    <Skeleton width="10rem" />
                  </FlexBox>
                  <Skeleton width="100%" height="30px" />
                </FlexBox>
              </FlexBox>
            </CampaignCreationWrapper>
          </Layout>
        </div>
      </MaxHeightContainer>
    </div>
  );
};
export default CampaignCreationSkeleton;
